import { createStore } from 'vuex';
import person from './modules/person';
import notification from './modules/notification';

export default createStore({
    modules: {
        person,
        notification,
    },
});